export default __webpack_public_path__ + "static/media/Phone_Black.5823a79f.webp";